import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NgbActiveModal } from '../../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { Frequency, MitigatingAction } from "../../_interfaces/MitigatingAction.model";
import { RepositoryService } from "../../shared/services/repository.service";

@Component({
    selector: 'app-mitigation-editor',
    templateUrl: './mitigation-editor.component.html',
    styleUrls: ['./mitigation-editor.component.css']
})
export class MitigationEditorComponent implements OnInit {
    mitigationForm = new FormGroup({
        title: new FormControl(''),
        description: new FormControl(''),
        controlType: new FormControl(''),
        frequency: new FormControl(''),
        automatic: new FormControl(''),
        // riskId: new FormControl(''), // Known from Parent
        controlWeighting: new FormControl('0'),
        controlEffectiveness: new FormControl('0'),
        keyStatus: new FormControl(''),
        //reviewAndUpdateDate: new FormControl(''),
        costBased: new FormControl(''),
        costReduction: new FormControl(''),

    });

    mitigatingAction: MitigatingAction = new MitigatingAction();
  submitted: boolean;

    @Input() my_modal_title;
  @Input() my_risk_id;
  @Input() costBased;
  @Input() riskOwnerId;
    //@Output() messageToEmit = new EventEmitter<string>();

  constructor(private repository: RepositoryService, public activeModal: NgbActiveModal) { }

  get Frequency(): typeof Frequency{
    return Frequency;
  }

  ngOnInit() {
    this.f.costBased.setValue(this.costBased);

    if (this.costBased) {
      this.f.controlWeighting.disable();
      this.f.controlEffectiveness.disable();
    } else {
      this.f.costReduction.disable();
    }
  }

  onAddMitigation() {

    this.activeModal.close('Close click');
  }
    onSubmit() {
      // console.warn(this.mitigationForm.value);
      //let riskId: number = this.my_risk_id;
      this.submitted = true;
      this.mitigatingAction.id = 0;
      this.mitigatingAction.controlOwner = this.riskOwnerId;

      this.mitigatingAction.riskId = + this.my_risk_id;
      this.mitigatingAction.title = this.f.title.value;
      this.mitigatingAction.description = this.f.description.value;
      this.mitigatingAction.controlType =  + this.f.controlType.value;
      this.mitigatingAction.frequency = + this.f.frequency.value;
      this.mitigatingAction.controlStatus = 1;
      this.mitigatingAction.prevention = true;


      if (this.f.automatic.value === "true" || this.f.automatic.value === true) {
        this.mitigatingAction.automatic = true;
      } else {
        this.mitigatingAction.automatic = false;
      }

      this.mitigatingAction.controlWeighting = + 100 // RDP-69 // this.f.controlWeighting.value;

      this.mitigatingAction.controlEffectiveness = + this.f.controlEffectiveness.value;
      this.mitigatingAction.effectiveness = + this.f.controlEffectiveness.value;

      //this.mitigatingAction.keyStatus = this.f.keyStatus.value;
      if (this.f.keyStatus.value === "true" || this.f.keyStatus.value === true) {
        this.mitigatingAction.keyStatus = true;
      } else {
        this.mitigatingAction.keyStatus = false;
      }
      //if (!this.f.reviewAndUpdateDate.dirty) {
      //  alert('Please Set Review Date!');
      //  return;
      //}
      this.mitigatingAction.reviewAndUpdateDate = new Date();
      //this.mitigatingAction.costBased = this.f.costBased.value;
      if (this.costBased === true) {
        this.mitigatingAction.costBased = true;
        this.mitigatingAction.costReduction = + this.f.costReduction.value;
      } else {
        this.mitigatingAction.costBased = false;
        this.mitigatingAction.costReduction = 0;
        
      }

      let apiAddress: string = `MitigatingActions`;
      this.repository.create(apiAddress, this.mitigatingAction)
        .subscribe(res => {
            console.log(res);

            //this.messageToEmit.emit(`refresh`);
            this.activeModal.close('Submit click');
            // return res;
          },
          error => {
            //console.error("Error: ", error);
            alert('Error:!' + error.message + '\nPlease fill in all of the fields!\n');
          });
      // ,() => this.activeModal.dismiss() );

      // -- end of repository post call.

      // this.activeModal.dismiss();
    }
    // convenience getter for easy access to form fields
    get f() { return this.mitigationForm.controls; }
}
